import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import router from './routes/Routes';
import { AppStateProvider } from './hooks/AppSateContext';
import { bootApp } from './Redux/features/auth/authSlice';
import { useDispatch } from 'react-redux';
import { HeadProvider } from 'react-head';

export default function App() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(bootApp());
	}, [dispatch]);

	useEffect(() => {
		const syncAuth = (event) => {
			if (event.key === 'logout') {
				window.location.href = '/login';
			}
			if (event.key === 'login') {
				window.location.href = '/';
			}
		};

		window.addEventListener('storage', syncAuth);

		return () => {
			window.removeEventListener('storage', syncAuth);
		};
	}, [dispatch]);

	return (
		<HeadProvider>
			<AppStateProvider>
				<RouterProvider router={router} />
				<ToastContainer position='top-right' autoClose={3000} />
			</AppStateProvider>
		</HeadProvider>
	);
}
